import axiosInstance from "./axiosInstance";
const apiUrl = process.env.REACT_APP_API_URL;

export const filterTicketsApi = async (params) => {
  try {
    const response = await axiosInstance.get("api/filter-tickets/", {
      params: params,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to filter tickets",
    };
  }
};

export const getTicketsByDate = async (fromDate, toDate) => {
  try {
    const response = await axiosInstance.get(
      `api/tickets-by-date/?from_date=${fromDate}&to_date=${toDate}`,
    );

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to fetch tickets by date",
    };
  }
};

// filters for notes , role vise and time vise
export const filterNotesApi = async (params) => {
  try {
    const response = await axiosInstance.get("api/filter-notes/", {
      params: params,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to filter notes",
    };
  }
};

export const filterTimeSpentApi = async (params) => {
  try {
    const response = await axiosInstance.get("api/filter-timespent/", {
      params: params,
    });

    return {
      success: true,
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    return {
      success: false,
      message:
        error?.response?.data?.error ||
        error?.response?.data?.message ||
        "Failed to filter time spent",
    };
  }
};
